export default function () {
  if (document.getElementById('address-details-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "address-details-app" */ '@organisms/address-details/main');
  }
}
